'use strict';
export default function searchFollowMap() {
    let $inner = $('.js-search-map'),
        $header = $('header'),
        $parent = $('.js-search-view-part').filter('[data-mode="map"]'),
        $sibling = $('.js-search-view-part').filter('[data-mode="list"]'),
        $window = $(window);

    if (
        !$inner.length ||
        !$header.length ||
        !$parent.length ||
        !$sibling.length
    ) {
        return;
    }

    $window.on('load scroll', () => {
        let value = Math.max(
            Math.min(
                $window.scrollTop() - $parent.offset().top + $header.height() + 40,
                $sibling.height() - $inner.height()
            ),
            0
        );

        $inner.css('top', value);
    });
}
